export const calcCSSProgressValue = (
  progress: string,
  from: string,
  to: string,
) => {
  return `calc(${from} + calc(${progress} * calc(${to} - ${from})))`;
};
